var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPewMediaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z",
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2407_18578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1102 63.3332H29.8881C21.9797 63.3332 16.667 57.7866 16.667 49.5298V30.4722C16.667 22.2154 21.9797 16.6665 29.8881 16.6665H50.1126C58.0209 16.6665 63.3337 22.2154 63.3337 30.4722V49.5298C63.3337 57.7866 58.0209 63.3332 50.1102 63.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2382 32.2416C38.2382 35.4383 35.6366 38.0399 32.4399 38.0399C29.2409 38.0399 26.6416 35.4383 26.6416 32.2416C26.6416 29.0449 29.2409 26.4409 32.4399 26.4409C35.6366 26.4409 38.2382 29.0449 38.2382 32.2416ZM57.2675 44.871C57.8112 45.3983 58.2008 46.0003 58.4575 46.642C59.2345 48.5833 58.8308 50.9167 58.0002 52.8393C57.0155 55.1283 55.1302 56.8573 52.7548 57.6133C51.7002 57.9517 50.5942 58.0963 49.4905 58.0963H29.9348C27.9888 58.0963 26.2668 57.6437 24.8552 56.7943C23.9708 56.2623 23.8145 55.0373 24.4702 54.2393C25.5668 52.9093 26.6495 51.5747 27.7415 50.2283C29.8228 47.6523 31.2252 46.9057 32.7838 47.5613C33.4162 47.832 34.0508 48.2403 34.7042 48.6697C36.4448 49.8223 38.8645 51.4043 42.0518 49.687C44.2305 48.4957 45.4952 46.4571 46.596 44.6828L46.6182 44.647C46.6922 44.5282 46.7657 44.4095 46.8389 44.2912C47.2132 43.6864 47.5819 43.0907 47.9995 42.5423C48.5175 41.8633 50.4402 39.74 52.9252 41.252C54.5095 42.204 55.8418 43.492 57.2675 44.871Z",
    fill: "#47AD1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2407_18578",
    x: 3.82545,
    y: 3.82545,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.82545,
    dy: 1.82545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2407_18578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2407_18578",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPewMediaIcon);
export default __webpack_public_path__ + "static/media/pew-media-icon.be16e5d0626dc994a4cd03fd83592039.svg";
export { ForwardRef as ReactComponent };